// Third Party
import * as React from 'react';
import { Session } from 'next-auth';
import cx from 'classnames';
// import { AxiomWebVitals } from 'next-axiom';

// Utils
import { WithChildrenCommonProps } from '@types';
import { LoginAndSignupModalsProvider } from '@contexts/use-login-and-signup-modals';

// UI
import { Head } from './head';
import { DesktopNav } from './desktop-nav';
import { Footer } from './footer';
import { AcceptCookieFooter } from './accept-cookie-footer';

type Props = {
  canonicalUrl: string;
  isFooterVisible?: boolean;
  listings?: { name: string; slug: string }[];
  noIndex?: boolean;
  pageDescription: string;
  pageTitle: string;
  session: Session | null;
  imageUrl?: string;
  navbar?: React.ReactNode;
  loadingSession: boolean;
  isFullWidth?: boolean;
};

export const PublicLayout: React.FC<WithChildrenCommonProps<Props>> = ({
  canonicalUrl,
  children,
  isFooterVisible = true,
  noIndex = false,
  pageDescription,
  pageTitle,
  session,
  loadingSession,
  imageUrl,
  navbar,
  isFullWidth = false,
}) => {
  return (
    <LoginAndSignupModalsProvider>
      <Head
        canonicalUrl={canonicalUrl}
        noIndex={noIndex}
        pageTitle={pageTitle}
        pageDescription={pageDescription}
        imageUrl={imageUrl}
      />
      <div
        className={cx('relative', {
          'body-container': !isFullWidth,
        })}
      >
        {navbar || (
          <DesktopNav session={session} loadingSession={loadingSession} />
        )}

        {children}

        <AcceptCookieFooter />

        {isFooterVisible && <Footer session={session} />}
      </div>
      {/* <AxiomWebVitals /> */}
    </LoginAndSignupModalsProvider>
  );
};
